import { useEffect, useRef } from 'react';
import { MARD_291 } from '../core/palette';
import type { PatternProject } from '../types';

export function ProjectThumbnail({ project }: { project: PatternProject }) {
  const ref = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const size = 84;
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, size, size);
    const scale = Math.min(size / project.width, size / project.height);
    const width = project.width * scale;
    const height = project.height * scale;
    const x = (size - width) / 2;
    const y = (size - height) / 2;
    const pixels = document.createElement('canvas');
    pixels.width = project.width;
    pixels.height = project.height;
    const pixelContext = pixels.getContext('2d');
    if (!pixelContext) return;
    const image = pixelContext.createImageData(project.width, project.height);
    for (let index = 0; index < project.colorIndices.length; index += 1) {
      const offset = index * 4;
      if (project.empty[index]) {
        image.data[offset + 3] = 0;
        continue;
      }
      const hex = MARD_291[project.colorIndices[index]]?.hex || '#ffffff';
      const value = Number.parseInt(hex.slice(1), 16);
      image.data[offset] = (value >> 16) & 255;
      image.data[offset + 1] = (value >> 8) & 255;
      image.data[offset + 2] = value & 255;
      image.data[offset + 3] = 255;
    }
    pixelContext.putImageData(image, 0, 0);
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(pixels, x, y, width, height);
  }, [project]);

  return <canvas ref={ref} className="project-thumb" aria-hidden="true" />;
}
